import { api, clearAuth, persistAuth } from "@/api/client";
import type { AuthMe, AuthTokens, UpdateProfileInput } from "@/types/api";

export async function login(
  email: string,
  password: string,
): Promise<AuthTokens> {
  const data = await api<AuthTokens>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
    skipAuth: true,
  });
  persistAuth(data);
  return data;
}

export type OtpChannel = "email" | "sms";

export type SendOtpResult = {
  message: string;
  devCode?: string;
};

export async function sendOtp(input: {
  channel: OtpChannel;
  email?: string;
  phone?: string;
}): Promise<SendOtpResult> {
  return api<SendOtpResult>("/auth/otp/send", {
    method: "POST",
    body: JSON.stringify(input),
    skipAuth: true,
  });
}

export async function verifyOtp(input: {
  channel: OtpChannel;
  email?: string;
  phone?: string;
  code: string;
}): Promise<AuthTokens> {
  const data = await api<AuthTokens>("/auth/otp/verify", {
    method: "POST",
    body: JSON.stringify(input),
    skipAuth: true,
  });
  persistAuth(data);
  return data;
}

export async function register(input: {
  email: string;
  password: string;
  displayName?: string;
  fullName?: string;
  locale?: string;
}): Promise<{
  needsVerification: true;
  email: string;
  message: string;
  devCode?: string;
}> {
  return api("/auth/register", {
    method: "POST",
    body: JSON.stringify(input),
    skipAuth: true,
  });
}

export async function getMe(): Promise<AuthMe> {
  return api<AuthMe>("/auth/me");
}

export async function updateProfile(
  input: UpdateProfileInput,
): Promise<AuthMe> {
  return api<AuthMe>("/auth/me", {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function logout(): void {
  clearAuth();
}
